module.exports = __webpack_public_path__ + "images/saaremaa/og-image.png";